import { forwardRef } from 'react';
const genericForwardRef = forwardRef;
export default genericForwardRef;
